// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__d54aI","headerOpt":"header_headerOpt__M8Hi5","logo":"header_logo__n_dqR"};